import { OAuthLoginAPICallCreator, OAuthHandleCallbackAPICallCreator } from '../lib/oauth/api'

export const login = OAuthLoginAPICallCreator('/auth/outlook365')

export const handleCallback = OAuthHandleCallbackAPICallCreator('/auth/outlook365')
